export default __webpack_public_path__ + "images/brand-logo.45100f9bab3cc610579d4fe65cf2de71.png";